import React, { useState } from 'react';
import { Container, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://backend.writerswright.com/api/v1/login', {
        email,
        password,
      });
      console.log(response.data);
      const { id, name: userName, email: userEmail, role } = response.data;

      // Store data in cookies
      Cookies.set('id', id);
      Cookies.set('name', userName);
      Cookies.set('email', userEmail);
      Cookies.set('role', role);

      // Redirect based on role
      if (role === 'Student') {
        navigate('/students-portal');
      } else if (role === 'Teacher') {
        navigate('/teachers-portal');
      } else if (role === 'Admin') {
        navigate('/admin-portal');
      } else {
        navigate('/');
      }
    } catch (error) {
      alert(error)
      setError('Invalid credentials, please try again.');
    }
  };

  return (
    <div 
      className="d-flex flex-column justify-content-center align-items-center vh-100" 
      style={{ background: '#f8f9fa' }}
    >
      <div 
        style={{
          maxWidth: '400px',
          width: '100%',
          padding: '20px',
          border: '1px solid #ccc',
          borderRadius: '10px',
          backgroundColor: 'white',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
        }}
      >
        <h1 className="text-center mb-4 title">Login</h1>
        {error && <p className="text-danger text-center">{error}</p>}
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label className='text'>Enter Email</Form.Label>
            <Form.Control 
              type="text" 
              placeholder="Enter your email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="formBasicPassword">
            <Form.Label className='text'>Enter Password</Form.Label>
            <Form.Control 
              type="password" 
              placeholder="Password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>

          <button 
            className="button-37" 
            role="button" 
            style={{ width: "100%", marginTop: "9px" }}
            type="submit"
          >
            Submit
          </button>

          <div className="mt-3 text-center">
            <a href="#" className='text'>Forgot Password?</a>
          </div>

          <Row className="mt-3">
            <Link to="/student-register"><p className="text-center text">Are you a student? <a href="#">Register as Student</a></p></Link>
            <Link to="/teacher-register"><p className="text-center text">Are you a teacher? <a href="#">Register as Teacher</a></p></Link>
          </Row>
        </Form>
      </div>
      <div className="mt-5 text-center">
        <p>© 2024 Copyright: writerswright</p>
      </div>
    </div>
  );
}

export default Login;
